'use strict';

var navigateAwayFromEditorHandler = null;

(function (snapOnline, $) {
    // Ensure required nested namespaces are declared.
    snapOnline.TabLayout = snapOnline.TabLayout || {};

    // ----- Public interface from here -----

    // Adds the 'active' CSS class to the element with the specified ID, and removes
    // it from all siblings.  Used to highlight an item in the accordion.
    snapOnline.TabLayout.setActivePanelId = function (panelId) {
        var panelLink = $('#' + panelId);
        if (panelLink.length) {
            panelLink.siblings().removeClass('active');
            panelLink.addClass('active');
        }
    };

    // Refresh the "legend" - this is the Survey name and status (such as "My Survey - Started, 3 respondents")
    // that appears above the four main tabs of the application.
    snapOnline.TabLayout.refreshSurveyTitleAndStatus = function () {
        snapOnline.replaceElementWithAjaxGet('legend', snapOnline.getResourceActionUrl('Resource', 'Legend'));
    };

    // Registers a function, provided by the JS Survey Editor, which is called when the user
    // clicks on any link in the SOL "header" area (which would have the effect of leaving
    // the editor).  This allows the editor to display a friendly "are you sure?" message.
    snapOnline.TabLayout.setNavigateAwayFromEditorHandler = function (remoteHandler) {
        if (remoteHandler) {
            if (navigateAwayFromEditorHandler === null) {
                var handler = function (e) {
                    e.preventDefault();
                    navigateAwayFromEditorHandler($(e.target).closest('a').attr('href'));
                    return false;
                };
                $('a[data-editor-intercepts-click]').click(handler);
            }
            navigateAwayFromEditorHandler = remoteHandler;
        }
    };
}(window.SnapOnline = window.SnapOnline || {}, jQuery));
